
import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, CardBody, Col, Form, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { BASE_API_URL } from "../../../../api";


export const OnholdClaim = ({onholdModal, setShowOnholdClaim, showOnholdClaim, handleOnholdClaim}) => {
    const [comments, setComments] = useState("");

    





    return(
        <Modal isOpen={showOnholdClaim} toggle={onholdModal} size="xl">
        <ModalHeader>{`Put Claim On-hold`} </ModalHeader>
        <ModalBody>
          <CardBody>
            <Form className="needs-validation" noValidate="">
              <Col md="3 mb-3">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "57%", marginRight: "1rem" }}>
                    {"Comments"}
                  </Label>
  
                  <textarea
                    style={{width: "30rem"}}
                    className="form-control"
                    name="comments"
                    type="text"
                    placeholder="Comment"
                    onChange={(e) => setComments(e.target.value)}
                    // value={claimID}
                  />
                </div>
              </Col>
            </Form>
          </CardBody>
        </ModalBody>
        <ModalFooter>
        <Button color="secondary" onClick={onholdModal}>
            Close
          </Button>
          <Button color="primary" onClick={()=>handleOnholdClaim(comments)}>
            Submit
          </Button>

        </ModalFooter>
      </Modal>
    )
}